import { Fuel, FuelInterface, FuelPropName } from '../../../../models/project/plant-specifications/fuel.model';
import { ValidationInterface } from '../../validation.interface';
import { ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';

export class FuelValidation implements ValidationInterface {
  /** The current fuel obj that is being validated */
  fuel: Fuel;

  /**
   * Sets the fuel obj that will be used for validation
   * @param fuel will be used to set the current fuel obj
   */
  constructor(fuel: FuelInterface) {
    if (!fuel) throw Error('invalid fuel provided for validation');
    this.fuel = new Fuel(fuel);
  }

  /**
   * Get a validation unit containing the validation data for the current fuel obj
   */
  getValidation(): ProjectValidationUnit {
    if (!this.fuel) throw Error('unable to validation fuel');
    const validationUnit = new ProjectValidationUnit();

    if (this.fuel.name) {
      validationUnit.setValid(FuelPropName.name);
    } else {
      validationUnit.setInvalid(FuelPropName.name, [FuelError.MissingName]);
    }
    if (this.fuel.perType !== 'please select') {
      validationUnit.setValid(FuelPropName.period_typ);
    } else {
      validationUnit.setInvalid(FuelPropName.period_typ, [FuelError.MISSING_PERTYPE]);
    }

    if (this.fuel.type && this.fuel.type !== 'other') {
      validationUnit.setValid(FuelPropName.type);
    } else {
      validationUnit.setInvalid(FuelPropName.type, [FuelError.MissingType]);
    }
    validationUnit.addModuleResults(
      new UnitValueValidation(this.fuel.quantity).getValidation(),
      FuelPropName.quantity
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.fuel.period).getValidation(),
      FuelPropName.period
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.fuel.usageIncrease).getValidation(),
      FuelPropName.usageIncrease
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current fuel obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}

/**
 * An enum that contains errors that relate to fuel validation
 */
enum FuelError {
  MissingName = 'VALIDATION.MISSING_NAME',
  MissingType = 'VALIDATION.MISSING_TYPE',
  MISSING_PERTYPE = 'VALIDATION.MISSING_PERTYPE',

}
